import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Badge, Button, Icon, List, Popover} from "antd";
import {Link, NavLink} from "react-router-dom";
import {connect} from "react-redux";
import {ackNotifications} from "../../actions/notifications";
import {dateSort} from "../../projections";
import moment from "moment";
import UserSmall from "./UserSmall";
import URI from 'urijs';
import CompanySmall from "./CompanySmall";

class NotificationButton extends Component {
  /*
  content = [
    {
      key: ''
      title: ''
      text: ''
      target: ''
      time: moment()
    }
   ]
  */

  handleAck = (id) => {
    const { onAck } = this.props;
    if (onAck) {
      onAck(id);
    }
  };

  getContent = (content) => (
    <div className={'notifications-scrollable notifications-popover'}>
      <List
        dataSource={content}
        locale={{emptyText: 'No new notifications. All caught up!'}}
        renderItem={item => <List.Item
          actions={[
            <Icon type='close-circle' fill='red' onClick={() => this.handleAck(item.key)}/>
          ]}
          key={item.key}
        >
          <List.Item.Meta
            title={item.target ? <NavLink to={item.target}>{item.title}</NavLink> : item.title}
            description={
              <div className='notifications-text'>
                {item.text}
              </div>
            }
          />
          {item.time.fromNow()}
        </List.Item>
        }
      />
    </div>
  );

  render() {
    const { content, style, className } = this.props;
    const totalCount = content.length;
    return (
      <div
        style={style}
        className={'notifications-button ' + className}
      >
        <Popover
          placement='bottomRight'
          trigger='click'
          content={this.getContent(content)}
          getPopupContainer={trigger => trigger.parentNode}
        >
          <Button>
            <Badge className='badge-mini' offset={[2, -2]} count={totalCount}><Icon type='mail'/></Badge>
            <span className='hidden inline visible-sm'>Messages</span>
          </Button>
        </Popover>
      </div>
    );
  }
}

NotificationButton.propTypes = {
  content: PropTypes.object,
  onAck: PropTypes.func
};

const GUI_BASE = '/';

const buildBidUri = (id) => {
  let url = URI.joinPaths(GUI_BASE, 'bids', id);
  return url.toString();
};

const buildProjectUri = (id) => {
  let url = URI.joinPaths(GUI_BASE, 'projects', id);
  return url.toString();
};

const mapNotificationToView = (note) => {
  try {
    let view = {
      time: note.datecreated,
      text: '',
      key: note.historyid
    };
    switch (note.segmenttype) {
      case 'bid_invite':
        view.text = <span>
            <UserSmall id={note.createdbyuserid}/> has invited you to a <Link to={buildBidUri(note.associatedid)}>bid</Link>.
          </span>;
        break;
      case 'project_invite':
        view.text = <span>
            <UserSmall id={note.createdbyuserid}/> has invited you to a <Link to={buildProjectUri(note.associatedid)}>project</Link>.
          </span>;
        break;
      case 'company_add':
        view.title = 'You have been accepted to a company';
        view.text = <span><UserSmall id={note.createdbyuserid}/> has added you to <Link
          to={'/settings/company-profile'}><CompanySmall id={note.createdbycompanyid}></CompanySmall></Link>.</span>;
        break;
      case 'company_apply':
        view.text = <span>
            <UserSmall id={note.createdbyuserid}/> has <Link to={'/settings/company-profile'}>requested to join</Link> your company.
          </span>;
        break;
      case 'bid_kick':
        view.text = <span>
            <UserSmall id={note.createdbyuserid}/> has removed you from a <Link to={buildBidUri(note.associatedid)}>bid</Link>.
          </span>;
        break;
      case 'project_kick':
        view.text = <span>
            <UserSmall id={note.createdbyuserid}/> has removed you from a <Link to={buildProjectUri(note.associatedid)}>project</Link>.
          </span>;
        break;
      case 'archive_request':
        view.title = 'You have requested a download archive';
        break;
      case 'archive_accept':
        view.title = 'Download archive is being generated';
        break;
      case 'archive_reject':
        view.title = 'Download archive could not be created';
        break;
      case 'archive_ready':
        view.text = <span><a href={note.fields.url}>Download archive</a> is ready</span>;
        break;
      default:
        view.title = 'Unknown message type';
    }
    return view;
  } catch (error) {
    return {
      title: 'Unknown message',
      text: 'Cannot render message',
      time: moment(),
    };
  }
};

export default connect(
  (state, props) => {
    let msgs = Object.values(state.notifications.data)
      .sort(dateSort(['datecreated'], true))
      .map(value => mapNotificationToView(value));
    return {
      content: msgs,
    };
  },
  (dispatch, props) => ({
    onAck: (id) => dispatch(ackNotifications([id]))
  })
)(NotificationButton);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/NotificationButton.js